/* eslint-disable camelcase */
import { TFunction } from "i18next";
import {
  GetAccount200ResponsePositionsInner,
  InstrumentTypeResponse,
} from "../../../../codegen-api";
import RowActionButton from "../../../../components/shared/RowActionButton";
import {
  TPSLCell,
  TPSLContainer,
} from "../../../../components/shared/Table/style";
import { SPACING } from "../../../../constants/design/spacing";
import { usePositionTpslDisplay } from "../../../../hooks/tpsl/useTpslDisplay";
import { Label } from "../../../PortfolioOverviewTab/style";
import { Stat, Stats, StatValue } from "../style";

interface IMobilePositionTpslProps {
  position: GetAccount200ResponsePositionsInner;
  price_precision: number;
  t: TFunction;
  /** Omitted on chains without a TP/SL executor — the row then hides this stat. */
  setTpslModalPositionId?: (id: string) => void;
}

/**
 * TP/SL stat on the mobile position card. Lookup and formatting are shared with
 * the desktop cell and the tablet card via usePositionTpslDisplay.
 */
function MobilePositionTpsl({
  position,
  price_precision,
  t,
  setTpslModalPositionId,
}: IMobilePositionTpslProps) {
  // Called before the early return — hooks must not be conditional.
  const { takeProfitLabel, stopLossLabel, tpslSupported } =
    usePositionTpslDisplay(position, price_precision);

  // Hidden entirely where the chain has no trigger executor, matching the
  // trade-form checkbox and the desktop column.
  if (!setTpslModalPositionId || !tpslSupported) {
    return null;
  }

  return (
    <Stats>
      <Stat>
        <Label>{t("tpsl_for_position")}</Label>
        <StatValue>
          <TPSLContainer>
            <TPSLCell>
              <span>{takeProfitLabel}</span>
              <span>{stopLossLabel}</span>
            </TPSLCell>
            <RowActionButton
              variant="edit"
              aria-label="Edit take profit / stop loss"
              onClick={(e) => {
                e.stopPropagation();
                setTpslModalPositionId(position.instrument_id);
              }}
              disabled={
                position.instrument_type !== InstrumentTypeResponse.Perpetual
              }
              style={{ marginLeft: SPACING.two }}
            />
          </TPSLContainer>
        </StatValue>
      </Stat>
    </Stats>
  );
}

export default MobilePositionTpsl;
